import { availableExaktaCanvasSKUs, availableExaktaPosterSKUs, availableExaktaStockItemSKUs, availableExaktaTShirtSKUs } from "../common-third-party/exakta/skus/available";
import { IPosterOrderItem } from "../common-interfaces/poster-order";
import { PosterSize } from "../common-types/poster-size";
import { availableTexPrintClothesSKUs, texPrintProductNamesBySKU } from "../common-third-party/texprint/skus/available";

export const productNamesBySKU = Object.assign({}, texPrintProductNamesBySKU);

export const allAvailableSKUs = [].concat(
    availableExaktaPosterSKUs,
    availableExaktaCanvasSKUs,
    availableTexPrintClothesSKUs,
    availableExaktaStockItemSKUs,
    availableExaktaTShirtSKUs
)

export const mugColors = ['WHITE', 'RED', 'PINK', 'GREEN', 'BLUE', 'BLACK', 'YELLOW'];

/** SKUs of the OTHER products, without the OTHER_ prefix */
export const availableOtherProductSKUs = ['STUDENT-SIGN'].concat(mugColors.map(color => `MUG-${color}`));

export interface IOtherProductInfo {
    /** SKU sent to Exakta */
    sku: string,
    /** Key in otherSizesByName */
    size: string,
    metadata: {
        mugColor?: string
    }
}

/**
 * Resolves an OTHER product SKU, e.g. OTHER_MUG-WHITE or MUG-WHITE, to the Exakta SKU,
 * print size and item metadata. Returns null if the SKU isn't an OTHER product.
 */
export const getOtherProductInfo = (sku: string): IOtherProductInfo => {
    let code = String(sku || '').trim().toUpperCase().replace(/^OTHER_/, '');

    if (code == 'STUDENT-SIGN') {
        return { sku: 'STD_STUDENT_50x70', size: 'STD_STUDENT_50x70', metadata: {} };
    }

    if (code.startsWith('MUG-')) {
        let color = code.replace('MUG-', '');
        if (mugColors.includes(color))
            return { sku: 'STD_MUG_11', size: 'STD_MUG_11', metadata: { mugColor: color.toLowerCase() } };
    }

    return null;
}

/** Sets the Exakta SKU, size and metadata of an OTHER order item from its SKU. Returns false if the SKU isn't an OTHER product. */
export const applyOtherProductInfo = (item: IPosterOrderItem, sku: string): boolean => {
    let otherProductInfo = getOtherProductInfo(sku);
    if (!otherProductInfo)
        return false;

    item.posterType = 'OTHER';
    item.sku = otherProductInfo.sku;
    item.size = otherProductInfo.size as PosterSize;
    item.metadata = Object.assign({}, item.metadata, otherProductInfo.metadata);
    return true;
}

export const availableSkuInfoByPosterType: {
    [posterType: string]: {
        sku: string,
        size: string
    }[]
} = {
    'POSTER': availableExaktaPosterSKUs.map(sku => {
        return {
            sku: sku,
            size: sku.split('_')[1]
        }
    }),
    'CANVAS': availableExaktaCanvasSKUs.map(sku => {
        return {
            sku: sku,
            size: sku.split('_')[1]
        }
    }),
    'TSHIRT': availableTexPrintClothesSKUs.map(sku => {
        let split = sku.split('-');
        return {
            sku: sku,
            size: split[split.length - 1]
        }
    }),
    'CLOTHES': availableTexPrintClothesSKUs.map(sku => {
        let split = sku.split('-');
        return {
            sku: sku,
            size: split[split.length - 1]
        }
    }),
    'STOCK_ITEM': availableExaktaStockItemSKUs.map(sku => {
        return {
            sku: sku,
            size: null
        }
    }),
    'OTHER': availableOtherProductSKUs.map(sku => {
        return {
            sku: sku,
            size: getOtherProductInfo(sku).size
        }
    })
};


export const availableAdminSkuInfoByPosterType: {
    [posterType: string]: {
        sku: string,
        size: string
    }[]
} = {
    'TSHIRT': availableExaktaTShirtSKUs.map(sku => {
        let split = sku.split('-');
        return {
            sku: sku,
            size: split[split.length - 1]
        }
    })
};

export const clothesSKUsByCategory: { [category: string]: string[] } = {
    'TSHIRT': availableTexPrintClothesSKUs.filter(sku => {
        return sku.startsWith('G64000')
            || sku.startsWith('G5000')
            || sku.startsWith('STTU758');
    }),
    'HOODIE': availableTexPrintClothesSKUs.filter(sku => {
        return sku.startsWith('JH001')
    }),
    'SWEATSHIRT': availableTexPrintClothesSKUs.filter(sku => {
        return sku.startsWith('JH030')
    }),
    'KIDS': availableTexPrintClothesSKUs.filter(sku => {
        return sku.startsWith('G64000K') || sku.startsWith('BZ10')
    })
};